/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { Assert } from "abweb/utils/Assert";
import Immutable from "immutable";
export let AbImmutableRecord;
(function (_AbImmutableRecord) {
  function Class(defaultState, name) {
    return class extends Immutable.Record(defaultState, name) {
      constructor(state) {
        super(Object.keys(state).filter(key => key in defaultState).reduce((accumulator, key) => {
          const value = state[key];
          value !== undefined && (accumulator[key] = value);
          return accumulator;
        }, {}));
      }
      with(partialState) {
        return this.merge(partialState);
      }
    };
  }
  _AbImmutableRecord.Class = Class;
  let State;
  (function (_State) {
    // A static class to return from the "from" method below, so ObjectUtils.deepCompare works
    // as expected (using a dynamic class fails the comparison due to different prototype).
    class ObjectImpl {
      constructor(_value) {
        this._value = _value;
      }
      get value() {
        return this._value;
      }
    }
    let Object;
    (function (_Object) {
      function from(value) {
        Assert.assert(value != null);
        return new ObjectImpl(value);
      }
      _Object.from = from;
      function fromNullable(value) {
        if (value != null) {
          return from(value);
        }
      }
      _Object.fromNullable = fromNullable;
    })(Object || (Object = _State.Object || (_State.Object = {})));
  })(State || (State = _AbImmutableRecord.State || (_AbImmutableRecord.State = {})));
})(AbImmutableRecord || (AbImmutableRecord = {}));
//# sourceMappingURL=AbImmutableRecord.js.map
